<input type="radio" [attr.name]="value" [id]="uniqueId" [value]="value" [checked]="checked" (focusin)="focusin()" (focusout)="focusout()" [disabled]="disabled"/>
<span class="a3l-ui-radio-item__indicator"></span>
<label [attr.for]="uniqueId"></label>
<ng-content></ng-content>
